import $ from 'jquery'
import Delegate from 'ftdomdelegate'


let delegateElement = new Delegate(document.querySelector('body'))
let notificationElm = document.querySelector('#shopify-section-notification')
let notificationCntElm = notificationElm.querySelector('.notificationBar__content')
let notificationTimeout

// Create event handler for successful addition.
// $(document).ajaxSuccess(function(event, jqxhr, settings) {
//   if (settings.url == "/cart.js") {
//     //   GET /cart.js complete
//   } else if (settings.url.indexOf("/cart/") !== -1) {
//     notificationElm.classList.remove('is-visible')
//     if (settings.url == "/cart/add.js") {
//       //   POST cart/add.js complete
//     notificationElm.classList.remove('is-visible')
//       document
//         .querySelector(".drawer-overlay")
//         .setAttribute("aria-hidden", "false");
//       $("#sidebar-cart").attr("aria-hidden", "false");
//     }
//     if (settings.url == "/cart/update.js") {
//       //   POST cart/update.js complete
//     }
//     if (settings.url == "/cart/change.js") {
//       //   POST cart/change.js complete
//     }
//     if (settings.url == "/cart/clear.js") {
//       //   POST cart/clear.js complete
//     }
//   } else {
//     // NOT CART AJAX
//   }
// })

$(document).on('cart.requestComplete', function(event, cart) {
  notificationElm.classList.remove('is-visible')
    document
      .querySelector(".drawer-overlay")
      .setAttribute("aria-hidden", "false")
    $("#sidebar-cart").attr("aria-hidden", "false")
});

// Create event handler for failed addition.
$(document).ajaxError(function(event, jqxhr, settings, thrownError) {
  if (settings.url == "/cart.js") {
    // GET /cart.js error
  } else if (settings.url.indexOf("/cart/") !== -1) {
    notificationElm.classList.add('is-visible')
    clearTimeout(notificationTimeout)
    notificationTimeout = setTimeout(() =>{
        notificationElm.classList.remove('is-visible')
    },15000)
    if (settings.url == "/cart/add.js") {
      //   POST cart/add.js error
      if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
        notificationCntElm.innerHTML = 'Add to cart failed. Please try again.'
      } else {
        notificationCntElm.innerHTML = jqxhr.responseJSON.description
      }
    }
    if (settings.url == "/cart/update.js") {
      //   POST cart/update.js error'
      if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
        notificationCntElm.innerHTML = 'Update to cart failed. Please try again.'
      } else {
        notificationCntElm.innerHTML = jqxhr.responseJSON.description
      }
    }
    if (settings.url == "/cart/change.js") {
      //   POST cart/change.js error
      if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
        notificationCntElm.innerHTML = 'Change to cart failed. Please try again.'
      } else {
        notificationCntElm.innerHTML = jqxhr.responseJSON.description
      }
    }
    if (settings.url == "/cart/clear.js") {
      //   POST cart/clear.js error
      if(jqxhr.status == 0 || jqxhr.responseJSON == undefined) {
        notificationCntElm.innerHTML = 'Clear to cart failed. Please try again.'
      } else {
        notificationCntElm.innerHTML = jqxhr.responseJSON.description
      }
    }
  } else {
    // NOT CART AJAX
  }
})

delegateElement.on('click', '[data-action="close-notification"]', function () {
    notificationElm.classList.remove('is-visible')
})
var renderNewCartJSView = function () {
  $('[data-cart-barba]').each(function() {
    var view = rivets.bind($(this), CartJS.Rivets.model);
    CartJS.Rivets.boundViews.push(view);
  });
}
$('.productForm').each(function() {
  $(this).submit(function(event){
    let form = this
    event.preventDefault()
    
    let moxieCares = Array.from(form.getElementsByClassName('moxieCare')).map((item) => {
      let id = item.getAttribute('data-variant-id'),
          quantity = item.value
      ;
      if(quantity > 0) {
        return {
          id: id,
          quantity: quantity
        }
      } else {
        return false
      }
    })

    moxieCares.push({
      id: $(form).find('[name="id"]').val(),
      quantity: $(form).find('[name="quantity"]').val()
    })
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js', 
      data: {items: moxieCares}, 
      dataType: 'json',
      success: function() {
        CartJS.setAttribute('Has Moxie Care', true)
      }
    })
  })
})